require('intersection-observer')

// import appUtils from './app_utils'
import utils from './utils'

import Splitting from "splitting";

let targets
const toggleObserverOptions = {
 rootMargin: '0px',
 threshold: [0, 0.4, 1]
}

const body = document.querySelector('body')
const toggleObserverCallback = (entries, toggleObserver) => {
  entries.forEach(entry => {
    //if (entry.intersectionRatio < 0.2) {
    if (entry.isIntersecting) {
      if(entry.target.dataset.toggleclass) {
       body.classList.add(entry.target.dataset.toggleclass)
      }

      // if (entry.intersectionRatio > 0.4) {
      //   const eventName = entry.target.getAttribute('data-toggleclass-event')
      //   if (eventName) {
      //     appUtils.triggerEvent(eventName, entry)
      //   }
      // }

      entry.target.classList.add("in-view--in")

      if (entry.intersectionRatio > 0.4) {
        if (!entry.target.classList.contains("in-view--in-once")) {
          entry.target.classList.add("in-view--in-once")
          const video = entry.target.querySelector('video')
          if (video) {
            video.currentTime = 0
            video.play()
          }
        }
      }
      
    } else {
      if(entry.target.dataset.toggleclass) {
       body.classList.remove(entry.target.dataset.toggleclass)
      }
      entry.target.classList.remove("in-view--in")
    }
  });
};

// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/IntersectionObserver
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/observe
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/unobserve
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/disconnect
const toggleObserver = new IntersectionObserver(toggleObserverCallback, toggleObserverOptions);

const init = function() {
  targets = document.querySelectorAll(".in-view")
  if (targets.length) {
    targets.forEach((target) => {
      let textToSplit = null
      if (target.classList.contains('in-view--splitting')) {
        textToSplit = target
      } else {
        textToSplit = target.querySelector('.in-view--splitting')
      }
      if (textToSplit) {
        const splittedTitle = Splitting({ target: textToSplit, by: 'lines'})
      }
      toggleObserver.observe(target)
    })
  }
}

const destroy = function() {
  if (targets.length) {
    targets.forEach((target) => {
      toggleObserver.unobserve(target)
      if(target.dataset.toggleclass) {
        body.classList.remove(target.dataset.toggleclass)
      }
    });
  }
}

export default {init, destroy}
